angular
  .module('contributor')

  .factory('OSCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class OSCrud extends Crud {
        constructor(list) {
          super(
            'os' + (list || ''),
            '@@apiUrl' + '/os' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return OSCrud;
    }
  ]);
